import React, { useState } from "react";

const VoiceStatisticsExportModal = ({ onExport, onClose }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleExport = () => {
    onExport(startDate, endDate);
  };

  return (
    <div className="relative z-100">
      <dialog
        open
        className="flex flex-col gap-4 p-6 rounded-lg shadow-lg bg-white w-96 justify-center items-center"
      >
        <h2 className="text-xl font-bold">Export Voice Statistics</h2>
        <h3 className="text-lg font-semibold">Choose Date Range</h3>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label htmlFor="start-date">Start Date:</label>
            <input
              type="datetime-local"
              id="start-date"
              name="start-date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="end-date">End Date:</label>
            <input
              type="datetime-local"
              id="end-date"
              name="end-date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>
        <div className="flex justify-end gap-4">
          <button
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            onClick={handleExport}
          >
            Export
          </button>
          <button
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </dialog>
    </div>
  );
};

export default VoiceStatisticsExportModal;
